// extracted by mini-css-extract-plugin
export default {"register_wrap":"RegisterLayout_register_wrap__LuzKs","btn_start":"RegisterLayout_btn_start__fEgup","animate-rotate":"RegisterLayout_animate-rotate__IV79R"};